// Frontend/src/components/admin/ui/FileUpload.jsx
import { useState } from 'react';

const FileUpload = ({ label, onFileChange, preview, accept = 'image/*' }) => {
  const [file, setFile] = useState(null);

  const handleChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    onFileChange(selectedFile);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <div className="flex items-center">
        <input
          type="file"
          onChange={handleChange}
          accept={accept}
          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
        />
      </div>
      {preview && (
        <div className="mt-2">
          {accept.includes('image') ? (
            <img src={preview} alt="Preview" className="h-32 object-cover rounded" />
          ) : (
            <video controls className="h-32 w-full object-cover rounded">
              <source src={preview} type={file?.type} />
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      )}
    </div>
  );
};

export default FileUpload;